import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const SESSION_KEY = 'cjm_loaded'

export default function Preloader() {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem(SESSION_KEY))
  const [lineW, setLineW] = useState(0)

  useEffect(() => {
    if (!visible) return
    sessionStorage.setItem(SESSION_KEY, '1')

    const t1 = setTimeout(() => setLineW(100), 80)
    const t2 = setTimeout(() => setVisible(false), 1600)
    return () => { clearTimeout(t1); clearTimeout(t2) }
  }, [])

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: 'fixed', inset: 0, zIndex: 99999,
            background: '#000',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: 32,
          }}
        >
          {/* Logo mark */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            style={{ display: 'flex', alignItems: 'center', gap: 14 }}
          >
            <p style={{
              color: '#fff', fontWeight: 700, fontSize: 22,
              fontFamily: 'Geist Variable, sans-serif',
              letterSpacing: '-0.025em',
            }}>
              CJM <span style={{ color: '#22d3ee' }}>Studios</span>
            </p>
          </motion.div>

          {/* Progress bar */}
          <div style={{
            width: 160, height: 1,
            background: 'rgba(255,255,255,0.06)',
            borderRadius: 1, overflow: 'hidden',
          }}>
            <div style={{
              height: '100%',
              background: 'linear-gradient(90deg, #06b6d4, #22d3ee)',
              borderRadius: 1,
              width: `${lineW}%`,
              transition: 'width 1.3s cubic-bezier(.22,1,.36,1)',
              boxShadow: '0 0 12px rgba(6,182,212,0.8)',
            }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
